import { defineMessages } from 'react-intl';

export default defineMessages({
  renameProductValidationError: {
    id: 'app.products.rename.validation.error',
    defaultMessage: 'Error! Name must be less than 100 characters',
  },
  filterByLabel: {
    id: 'app.searchBar.filter.label.filterBy',
    defaultMessage: 'Filter by',
  },
  sortByLabel: {
    id: 'app.searchBar.filter.label.sortBy',
    defaultMessage: 'Sort by',
  },
  sortByOldestFirst: {
    id: 'app.searchBar.sort.category.oldestFirst',
    defaultMessage: 'Oldest',
  },
  sortByNewestFirst: {
    id: 'app.searchBar.sort.category.newestFirst',
    defaultMessage: 'Last updated',
  },
  sortByNameAlphabetical: {
    id: 'app.searchBar.sort.category.alphabetical',
    defaultMessage: 'A-Z',
  },
  allTemplatesFilter: {
    id: 'app.searchBar.filter.category.templates',
    defaultMessage: 'All templates',
  },
  allSizesFilter: {
    id: 'app.searchBar.filter.category.sizes',
    defaultMessage: 'All sizes',
  },
  clearAllFiltersButton: {
    id: 'app.searchBar.filter.button.clearAll',
    defaultMessage: 'Clear all',
  },
  selectAllProductsButton: {
    id: 'app.searchBar.button.selectAll',
    defaultMessage: 'Select all',
  },
  deselectAllProductsButton: {
    id: 'app.products.selection.deselect',
    defaultMessage: 'Deselect',
  },
  filterAndSortButton: {
    id: 'app.searchBar.button.filterAndSort',
    defaultMessage: 'Filter / Sort',
  },
  applyFiltersButton: {
    id: 'app.searchBar.filter.button.apply',
    defaultMessage: 'Apply',
  },
  addToCartButton: {
    id: 'app.products.cart.addAction',
    defaultMessage: 'Add to Cart',
  },
  addingToCart: {
    id: 'app.products.cart.adding',
    defaultMessage: 'Adding...',
  },
  addedToCart: {
    id: 'app.products.cart.added',
    defaultMessage: 'Added',
  },
  deleteProductButton: {
    id: 'app.products.delete.deleteAction',
    defaultMessage: 'Delete',
  },
  deletingProduct: {
    id: 'app.products.delete.deleting',
    defaultMessage: 'Deleting...',
  },
  deletedProduct: {
    id: 'app.products.delete.deleted',
    defaultMessage: 'Deleted',
  },
  tileMenuEditTooltip: {
    id: 'app.products.tileMenu.tooltip.edit',
    defaultMessage: 'Edit',
  },
  tileMenuDeleteTooltip: {
    id: 'app.products.tileMenu.tooltip.delete',
    defaultMessage: 'Delete',
  },
  tileMenuDownloadTooltip: {
    id: 'app.products.tileMenu.tooltip.download',
    defaultMessage: 'Download',
  },
  tileMenuProductUnavailable: {
    id: 'app.products.list.unavailable.overlayText',
    defaultMessage: 'Product not available',
  },
  editPaperType: {
    id: 'app.products.paperPicker.editPaper',
    defaultMessage: 'Edit Paper',
  },
  deleteDialogTitle: {
    id: 'app.dialog.delete.title',
    defaultMessage: 'Are you sure you want to delete?',
  },
  deleteDialogButtonDelete: {
    id: 'app.dialog.delete.button.delete',
    defaultMessage: 'Yes, delete',
  },
  deleteDialogButtonCancel: {
    id: 'app.dialog.delete.button.cancel',
    defaultMessage: 'No, keep',
  },
  deleteDialogButtonDescription: {
    id: 'app.dialog.delete.description',
    defaultMessage:
      'You are about to delete {formattedCheckedItemCount} {checkedItemCount, plural, one {product} other {products}}.',
  },
  selectProductDropdownLabel: {
    id: 'app.products.selectType.title',
    defaultMessage: 'Select product type',
  },
  productPendingApproval: {
    id: 'app.products.approvals.pending',
    defaultMessage: 'Awaiting approval',
  },
  productDeclinedApproval: {
    id: 'app.products.approvals.declined',
    defaultMessage: 'Declined',
  },
  productApprovedApproval: {
    id: 'app.products.approvals.approved',
    defaultMessage: 'Approved',
  },
  productDraftApproval: {
    id: 'app.products.approvals.draft',
    defaultMessage: 'Draft',
  },
  productPendingApprovalTooltip: {
    id: 'app.products.approvals.pending.tooltip',
    defaultMessage:
      "Your product needs to be reviewed before you can order. We'll email you once it's approved by your admin. If you need to make any changes in the meantime, simply edit the product. To cancel the request, please delete the product.",
  },
  productDeclinedApprovalTooltip: {
    id: 'app.products.approvals.declined.tooltip',
    defaultMessage:
      'Your product hasn’t been approved, please check your emails for more info. You can edit your product and resend for approval.',
  },
  productApprovedApprovalTooltip: {
    id: 'app.products.approvals.approved.tooltip',
    defaultMessage:
      'Good news – your product has been approved by your admin and is ready to order. Note that any changes to the product will result in a new approval request.',
  },
  productDraftApprovalTooltip: {
    id: 'app.products.approvals.draft.tooltip',
    defaultMessage:
      'Your product is still in draft mode. Before it can be ordered, you need to edit and submit your product for approval.',
  },
  productApprovalTooltipTitle: {
    id: 'app.products.approvals.tooltip.title',
    defaultMessage: "What's this?",
  },
});
